import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrentLanguage {
  private _currentLang = signal<string>('es');
  public currentLang = this._currentLang.asReadonly();

  setLanguage(lang: string) {
    this._currentLang.set(lang);
  }
}
